import { uploadPath, uploadFilePath } from '@helpers/variables'

// Image must be a File-object !
export const uploadImage = async (image) => {
  const formData = new FormData()
  formData.append('image', image)

  const uploadResponse = await fetch(uploadPath, {
    method: 'POST',
    body: formData,
  })

  const uploadResult = await uploadResponse.json()
  const {
    success,
    file: { url },
  } = uploadResult

  if (success) {
    const fileName = url.split('\\').pop().split('/').pop()
    return Promise.resolve(fileName)
  } else {
    return Promise.reject('Image upload error')
  }
}

export const uploadFile = async (file) => {
  const formData = new FormData()
  formData.append('file', file)

  const uploadResponse = await fetch(uploadFilePath, {
    method: 'POST',
    body: formData,
  })
  const uploadResult = await uploadResponse.json()
  const {
    success,
    file: { url },
  } = uploadResult

  if (success) {
    const fileName = url
    // .split('\\').pop().split('/').pop()
    return Promise.resolve(fileName)
  } else {
    return Promise.reject('File upload error')
  }
}

export const preventPublicRequest = (request) => {
  return window.user ? request : null
}
